import React, {
  ReactNode,
  MouseEvent,
  useCallback,
  HTMLAttributeAnchorTarget,
} from 'react';
import clsx from 'clsx';
import {
  NavLink,
} from 'react-router-dom';
import {
  useMixpanelTrack,
} from 'core/hooks';

type NavItemProps = {
  href?: string;
  trackLabel?: string;
  className?: string;
  activeClassName?: string;
  children: ReactNode;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  target?: HTMLAttributeAnchorTarget;
};

export default function NavItem({
  href = '#',
  trackLabel,
  className,
  activeClassName = '',
  children,
  onClick: _onClick,
  target,
}: NavItemProps) {
  const mixpanelTrack = useMixpanelTrack();
  const getItemClasses = ({ isActive }: { isActive: boolean }) => clsx(
    'flex items-center px-3 py-2.5 rounded text-sm hover:bg-gray-700 cursor-pointer border border-transparent focus-visible:border-white',
    { 'bg-[#404142] text-white font-medium': isActive },
    { [activeClassName]: isActive },
    className,
  );

  const onClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
    if (typeof _onClick === 'function') { _onClick(e); }
    mixpanelTrack('ClickedNavigationLink', { url: trackLabel ?? href });
  }, [_onClick]);

  return (
    <NavLink
      to={href}
      onClick={onClick}
      className={getItemClasses}
      target={target}
    >
      {children}
    </NavLink>
  );
}
